import * as React from "react";
const SvgTriangle = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 25", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 25, height: 25, style: {
  fill: "none"
} }), /* @__PURE__ */ React.createElement("path", { d: "M12.2,1,0,24H25Z", style: {
  fillRule: "evenodd"
} }));
export default SvgTriangle;
